// extracted by mini-css-extract-plugin
export default {"conversationListHeading":"ConversationList-module__conversationListHeading__Y0f2QRc","inner":"ConversationList-module__inner__aFKPtEE"};